import * as Models from 'contracts/models';

export const Endpoint = () => `/api/v4/admin/set-license-active/`;
export const Csrf = () => `/api/v3/admin/token/`;
export declare const QueryKey: never;
export type Payload = Models.Licenses.SetLicenseActiveRequest;
export type Response = Models.Licenses.SetLicenseActiveResponse;
